import { useTranslation } from 'react-i18next'

import { HTML_LINK_TARGET } from '../../../../../../constants/html'
import { useInitData, useLinkLikeClick } from '../../../../../../hooks'
import { getRequestProfilePathname } from '../../../../../../utils/link'
import { ICON_SIZE } from '../../../../../Icon'
import { MultiValuedListSize } from '../../../../../MultiValuedList'
import { RequestMultiValuedList, RequestTag } from '../../../../../Request'
import { STATUS_SIZE_24 } from '../../../../../Status'
import { TAG_HEIGHT } from '../../../../../Tag'
import Text from '../../../../../Text'
import { ListItems } from '../ListItems'

import { ListItem } from './ListItem'
import { QA_NAME_REQUEST_TAG_ITEM } from './NewsboardPostBodyMessageRequests.constants'
import {
  getRequestAddress,
  getRequestLabel,
} from './NewsboardPostBodyMessageRequests.utils'

import * as styles from './NewsboardPostBodyMessageRequests.module.css'

function NewsboardPostBodyMessageRequests({
  ratingType,
  requestDump,
  requests,
  requestStatusType,
  unread,
  visibleCount,
}) {
  const { t } = useTranslation()

  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const { availableSections } = useInitData()

  const requestType = requestStatusType || ratingType

  function handleOpenRequest(id, event) {
    handleClick({
      event,
      link: getRequestProfilePathname({ availableSections, id }),
      target: HTML_LINK_TARGET.blank,
    })
  }

  function handleMouseDownItem(id, event) {
    handleMouseDown({
      event,
      link: getRequestProfilePathname({ availableSections, id }),
    })
  }

  return (
    <div className={styles.request}>
      {requests.length > 0 && !ratingType ? (
        <Text isSecondary={!requestType} unread={unread}>
          {t(getRequestLabel(requestStatusType))}
        </Text>
      ) : null}
      {requestDump?.status ? (
        <RequestTag
          {...requests[0]}
          hasAvatar
          avatarProps={{ size: ICON_SIZE.size24 }}
          height={TAG_HEIGHT.height40}
          qaName={QA_NAME_REQUEST_TAG_ITEM}
          status={requestDump?.status}
          statusSize={STATUS_SIZE_24}
          onClick={handleOpenRequest}
          onMouseDown={handleMouseDownItem}
        />
      ) : (
        <RequestMultiValuedList
          Item={ListItem}
          Items={ListItems}
          className={styles.multiValuedList}
          items={requests}
          size={MultiValuedListSize.Large}
          visibleCount={visibleCount}
        />
      )}
      {ratingType ? (
        <Text isSecondary>{getRequestAddress(requests[0])}</Text>
      ) : null}
    </div>
  )
}

export default NewsboardPostBodyMessageRequests
